module.exports = __webpack_public_path__ + "images/bannerIT-bdb866d05f5f483d03d36117bfb7cd5f.png";